import React from 'react';
import driver from './icon/driver.svg';

var divStyle = {
    backgroundColor: 'white',
    borderRadius: '20px',
    // width: '150',
    height: '20%',
    boxShadow: '5px 5px 10px #aaaaaa',
    // marginLeft: '2%',
    // marginRight: '2%'
  };

export default class Card extends React.Component {
    constructor(props) {
    super(props);
    this.state = {};
    // console.log(showingCard,' ==???')
  }
    
  render() {
    const driverName = 'นายขับดี  มีเฮ'
    const carNumber = '10-0989'
    return (

        <div style={divStyle} >
                <table border='0' width='100%' align='center' style={{ paddingTop:'20px', fontSize:'18px', marginTop:'10px'}} >
                    <tbody>
                    <tr style={{height:'50px'  }}>
                       
                        <td  align='center'>
                            <img height="60px" width="60px" src={driver}  alt=""/>
                        </td>
                        <td >
                            <span style={{ marginLeft:'10px', align:'center', fontSize:'30px' }} >{driverName}</span><br/>
                            <span style={{ marginLeft:'10px', align:'center',  }} >หมายเลขรถ {carNumber}</span>
                            <br/>
                            <br/>
                        </td>
                    </tr>
                     {/*<tr style={{height:'5px', backgroundColor:'#CCD6DD' }}  >       
                        <td colSpan="2">
                        </td>
                    </tr>
                    <tr style={{height:'50px' }}  >       
                        <td  align='center' colSpan="2" >
                            <span style={{ marginLeft:'10px', align:'center', fontSize:'25px' }} >พฤติกรรมการขับขี่</span><br/>
                        </td>
                    </tr>

                    <tr style={{height:'35px'  }}>       
                        <td  align='left' >
                            จอดแช่
                        </td>   
                        <td  align='right' >
                            0 ครั้ง
                        </td>   
                    </tr>
                    
                    <tr style={{height:'35px'  }}>       
                        <td  align='left' >
                            วิ่งเร็ว
                        </td>   
                        <td  align='right' >
                            0 ครั้ง
                        </td>   
                    </tr>
                    
                    <tr style={{height:'35px'  }}>       
                        <td  align='left' >
                            วิ่งแซง
                        </td>   
                        <td  align='right' >
                            0 ครั้ง
                        </td>   
                    </tr>
                    
                    <tr style={{height:'35px'  }}>       
                        <td  align='left' >
                            วิ่งจี้
                        </td>   
                        <td  align='right' >
                            0 ครั้ง
                        </td>   
                    </tr>
                    
                    <tr style={{height:'35px'  }}>       
                        <td  align='left' >
                            ออกเส้นทาง
                        </td>   
                        <td  align='right' >
                            0 ครั้ง
                        </td>   
                    </tr> */}
                    </tbody>

                </table>
        </div>
    );
  }
}    


// WEBPACK FOOTER //
// ./src/driverCard.js